import { createContext, useContext, useMemo } from 'react';
import { createObjectIntentType, getIntents, toIntent, provider } from '../intent';
import { onRender } from './intentTypes';
import { deprecatedCss, getCascadingProperty } from './deprecatedCss';
const $css = Symbol('css');
const $raw = Symbol('raw');
const globalVarsIntent = createObjectIntentType('globalVars', (createIntent)=>(vars)=>createIntent(vars));
function toDecls(resolved) {
    // TODO(koop): Only regenerate CSS for properties that have changed or
    // whose dependencies have changed. Currently regenerates all properties.
    let decls = '';
    Object.keys(resolved).forEach((key)=>{
        decls += `${getCascadingProperty(key)}: ${resolved[key]};\n`;
    });
    return decls;
}
export function resolveGlobalVars(child, parent) {
    const raw = parent ? {
        ...parent[$raw],
        ...child
    } : child;
    // Proxy the raw variables so accessing a value lazily computes the value and
    // its dependencies.
    const proxy = new Proxy({
        [$raw]: raw
    }, {
        get (target, key) {
            if (!(key in target) && key in raw) {
                const value = raw[key];
                target[key] = typeof value === 'function' ? value(proxy) : value;
            }
            return target[key];
        },
        getOwnPropertyDescriptor (_target, key) {
            return Reflect.getOwnPropertyDescriptor(raw, key);
        },
        ownKeys () {
            return Reflect.ownKeys(raw);
        }
    });
    proxy[$css] = deprecatedCss(toDecls(proxy));
    return proxy;
}
const GlobalVarsContext = createContext(undefined);
const EMPTY_VARS = {
    [$raw]: {},
    [$css]: {}
};
export function useGlobalVars() {
    return useContext(GlobalVarsContext) || EMPTY_VARS;
}
export function useGlobalVarsCss() {
    return useGlobalVars()[$css];
}
export const globalVarsCss = onRender(()=>[
        useGlobalVarsCss()
    ]);
export function useGlobalVar(key) {
    return useGlobalVars()[key];
}
const processGlobalVars = onRender((props)=>{
    const parent = useContext(GlobalVarsContext);
    const vars = getIntents(globalVarsIntent, props);
    return useMemo(()=>{
        const resolved = resolveGlobalVars(vars, parent);
        return [
            provider(GlobalVarsContext, resolved),
            resolved[$css]
        ];
    }, [
        parent,
        vars
    ]);
});
export function deprecatedGlobalVars(vars) {
    return toIntent([
        globalVarsIntent(vars),
        processGlobalVars
    ]);
}

//# sourceMappingURL=globalVars.js.map